// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__N36ka","topHeader":"Header_topHeader__SUXVc","headerWrap":"Header_headerWrap__FY3Ti","shrink":"Header_shrink__fm0u+"};